import React, { forwardRef, PropsWithChildren, Ref, useContext } from 'react';

import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';
import { isWeb } from '@tamagui/core';

import { Box } from '../../Box';
import { LayoutContext } from './LayoutContext';
import { LayoutGroup } from './LayoutGroup';
import { ScrollView } from './ScrollView';

const { formLayout: formLayoutTokens } = tokens;

/**
 * Scrollable form page background. This should wrap all form page subcomponents
 * except for BottomNav. Extra padding is inserted at the bottom if a BottomNav
 * is present (because the BottomNav is positioned absolutely).
 */
export const ScrollContainer = forwardRef(function ScrollContainer(
  { children }: PropsWithChildren,
  ref: Ref<ScrollView>,
) {
  const { bottomNavHeight } = useContext(LayoutContext);

  return (
    <ScrollView
      // @ts-expect-error '100dvh' is a valid value on web
      style={{ height: isWeb ? '100dvh' : '100%' }}
      contentContainerStyle={{ flexGrow: 1 }}
      ref={ref}
    >
      <LayoutGroup
        flexGrow={1}
        backgroundColor={formLayoutTokens.color.background.page.default}
        // Set width to 100vw to prevent scrollbar from making column off-center
        width={isWeb ? '100vw' : undefined}
      >
        <Box
          flexGrow={1}
          backgroundColor={formLayoutTokens.color.background.layout.default}
          paddingBottom={bottomNavHeight}
        >
          {children}
        </Box>
      </LayoutGroup>
    </ScrollView>
  );
});
